import React from "react";
export default function List({ children }) {
  return (
    <div
      style={{
        position: "relative",
        background: "#fafafa",
        flexGrow: 1,
        overflowY: "auto",
        zIndex: 0,
      }}
    >
      <ul
        style={{
          maxHeight: "100%",
          listStyle: "none",
          padding: "0",
        }}
      >
        {children}
      </ul>
    </div>
  );
}
